import React from 'react';
import { ResumeSection } from './ResumeSection';

interface Props {
  skills: Record<string, string[]>;
  compact?: boolean;
}

export function SkillsSection({ skills, compact = false }: Props) {
  const entries = Object.entries(skills);
  if (!entries.length) return null;

  if (compact) {
    const allSkills = entries.flatMap(([, items]) => items).slice(0, 20);
    return (
      <ResumeSection title="Technical Skills">
        <p className="resume-skill-items">{allSkills.join(' · ')}</p>
      </ResumeSection>
    );
  }

  return (
    <ResumeSection title="Skills">
      <div className="resume-skills-grid">
        {entries.map(([category, items]) => (
          <div key={category} className="resume-skill-group">
            <h3 className="resume-skill-label">{category}</h3>
            <p className="resume-skill-items">{items.join(' · ')}</p>
          </div>
        ))}
      </div>
    </ResumeSection>
  );
}
